// extracted by mini-css-extract-plugin
export default {"noOfferContainer":"style_noOfferContainer__ymtcQ","top":"style_top__VHhLW","footer":"style_footer__68Hg9","icon":"style_icon__GyiqC"};